import React, { useState, useEffect } from "react";

const Navigation: React.FC = () => {
    const [scrolled, setScrolled] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 60);
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    useEffect(() => {
        document.body.style.overflow = menuOpen ? "hidden" : "";
        return () => { document.body.style.overflow = ""; };
    }, [menuOpen]);

    const close = () => setMenuOpen(false);

    return (
        <nav className={`navigation${scrolled ? " scrolled" : ""}`}>
            <div className="nav-inner">
                <a href="#top" className="nav-brand">
                    <span className="nav-brand-text">SYSLOGICS</span>
                </a>

                <div className={`nav-links${menuOpen ? " open" : ""}`}>
                    <a href="#about"    onClick={close}>About</a>
                    <a href="#services" onClick={close}>Services</a>
                    <a href="#partners" onClick={close}>Partners</a>
                    <a href="#contact"  onClick={close} className="nav-cta">Contact</a>
                </div>

                <button
                    className="nav-menu-btn"
                    onClick={() => setMenuOpen(v => !v)}
                    aria-label="Toggle menu"
                >
                    <span />
                    <span />
                    <span />
                </button>
            </div>
        </nav>
    );
};

export default Navigation;
